module.exports = __webpack_public_path__ + "static/media/phone.9d5a08d4.svg";